import * as React from "react";
const MenubarContext = /* @__PURE__ */ React.createContext(null);
if (process.env.NODE_ENV !== "production") MenubarContext.displayName = "MenubarContext";
function useMenubarContext(optional) {
  const context = React.useContext(MenubarContext);
  return context;
}
export {
  MenubarContext,
  useMenubarContext
};
//# sourceMappingURL=MenubarContext.js.map
